module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/adengiBannerImage-d3128231bbc937bd6f6a88e81dd92004.png";